import { CirclesError } from './circles-error';

export class InvalidExpenseIdError extends CirclesError {
	constructor() {
		super('The expenseId id is invalid or blank.');
	}
}
